import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GraphUtilsService {

  constructor() { }

  setThreshHolds(kpi, outliers, uslLsl) {
    if (kpi) {
      return {
        usl: uslLsl ? kpi.usl : null,
        lsl: uslLsl ? kpi.lsl : null,
        ucl: outliers ? kpi.withOutliersUcl : kpi.ucl,
        lcl: outliers ? kpi.withOutliersLcl : kpi.lcl,
        target: kpi.targetValue ? kpi.targetValue : null,
        avg: outliers ? kpi.withOutliersAvg : kpi.avg,
        avgPlus1Sigma: outliers ? kpi.withOutliersMaxy : kpi.maxy,
        avgMinus1Sigma: outliers ? kpi.withOutliersMiny : kpi.miny,
        avgPlus2Sigma: outliers ? kpi.withOutliersUwcl : kpi.uwcl,
        avgMinus2Sigma: outliers ? kpi.withOutliersLwcl : kpi.lwcl,
        setpoint: kpi.setpoint ? kpi.setpoint : null
      };
    } else {
      return null;
    }
  }
  setThreshHoldsBatch(kpi, outliers, uslLsl, isCapability) {
    if (kpi) {
      if (isCapability) {
        return {
          usl: uslLsl ? kpi.usl : null,
          lsl: uslLsl ? kpi.lsl : null,
          ucl: outliers ? kpi.withOutliersUcl : kpi.ucl,
          lcl: outliers ? kpi.withOutliersLcl : kpi.lcl,
          target: null,
          avg: outliers ? kpi.withOutliersAvg : kpi.avg,
          avgPlus1Sigma: null,
          avgMinus1Sigma: null,
          avgPlus2Sigma: null,
          avgMinus2Sigma: null,
          avgPlus3Sigma: null,
          avgMinus3Sigma: null,
          setpoint: kpi.setpoint ? kpi.setpoint : null
        };
      } else {
        return {
          usl: uslLsl ? kpi.usl : null,
          lsl: uslLsl ? kpi.lsl : null,
          ucl: outliers ? kpi.withOutliersUcl : kpi.ucl,
          lcl: outliers ? kpi.withOutliersLcl : kpi.lcl,
          avgPlus3Sigma: outliers ? kpi.withOutliersUcl : kpi.ucl,
          avgMinus3Sigma: outliers ? kpi.withOutliersLcl : kpi.lcl,
          target: null,
          avg: outliers ? kpi.withOutliersAvg : kpi.avg,
          avgPlus1Sigma: outliers ? kpi.withOutliersMaxy : kpi.maxy,
          avgMinus1Sigma: outliers ? kpi.withOutliersMiny : kpi.miny,
          avgPlus2Sigma: outliers ? kpi.withOutliersUwcl : kpi.uwcl,
          avgMinus2Sigma: outliers ? kpi.withOutliersLwcl : kpi.lwcl,
          setpoint: kpi.setpoint ? kpi.setpoint : null
        };
      }
    } else {
      return null;
    }
  }
  findBoundaryVals(actualData: any[], key, thresholds, type?, bufferFactor = 0.03): any {
    const boundaryVals = {
      max: -999999,
      min: 999999
    };

    actualData.forEach(element => {
      if (element[key] >= boundaryVals.max) {
        boundaryVals.max = element[key];
      }
      if (element[key] <= boundaryVals.min) {
        boundaryVals.min = element[key];
      }
    });

    if (thresholds) {
      if (thresholds.ucl !== null && boundaryVals.max < thresholds.ucl) {
        boundaryVals.max = thresholds.ucl;
      }

      if (thresholds.usl !== null && boundaryVals.max < thresholds.usl) {
        boundaryVals.max = thresholds.usl;
      }

      if (thresholds.lcl !== null && boundaryVals.min > thresholds.lcl) {
        boundaryVals.min = thresholds.lcl;
      }

      if (thresholds.lsl !== null && boundaryVals.min > thresholds.lsl) {
        boundaryVals.min = thresholds.lsl;
      }

      Object.keys(thresholds).forEach((key: string) => {
        if (thresholds[key] !== null && (thresholds[key] === 'usl' || thresholds[key] === 'ucl')) {
          boundaryVals.max = thresholds[key] > boundaryVals.max ? thresholds[key] : boundaryVals.max;
        }
        if (thresholds[key] !== null && (thresholds[key] === 'lsl' || thresholds[key] === 'lcl')) {
          boundaryVals.min = thresholds[key] < boundaryVals.min ? thresholds[key] : boundaryVals.min;
        }
      });
    }
    if (thresholds && ((thresholds.usl || thresholds.lsl) || (!thresholds.usl && !thresholds.lsl)) && type === 'histogram') {
      return {
        max: Math.ceil(boundaryVals.max * (boundaryVals.max >= 0 ? (1 + bufferFactor) : (1 - bufferFactor))),
        min: Math.floor(boundaryVals.min * (boundaryVals.min >= 0 ? (1 - bufferFactor) : (1 + bufferFactor))),
      };
    } else {
      return {
        max: boundaryVals.max,
        min: boundaryVals.min
      };
    }
  }

  getColorList() {
    return {
      normal: '#556060',
      rule1Violation: '#fe7160',
      rule6Violation: '#ff9d00',
      rule7Violation: '#00a3aa',
      setpoint: '#0185ca',
      outsideLslUsl: '#fff'
    };
  }

  addThresholdLines(chart, usllsl, thresholds) {
    if (usllsl) {
      chart.ygrids.add([
        { value: thresholds.usl, text: 'USL', class: 'specification-limit' },
        { value: thresholds.lsl, text: 'LSL', class: 'specification-limit' },
      ]);
    }
    chart.ygrids.add([
      { value: thresholds.ucl, text: 'UCL', class: 'control-limit' },
      { value: thresholds.lcl, text: 'LCL', class: 'control-limit' },
      { value: thresholds.avg, text: 'AVG', class: 'avg-val dashed' },
      { value: thresholds.target, text: 'TARGET', class: 'target dashed' },
    ]);
  }
  addThresholdLinesBatch(chart, usllsl, thresholds) {
    if (usllsl) {
      chart.ygrids.add([
        { value: thresholds.usl, text: 'USL', class: 'specification-limit' },
        { value: thresholds.lsl, text: 'LSL', class: 'specification-limit' },
      ]);
    }
    chart.ygrids.add([
      { value: thresholds.ucl, text: 'UCL', class: 'control-limit' },
      { value: thresholds.lcl, text: 'LCL', class: 'control-limit' },
      { value: thresholds.avg, text: 'AVG', class: 'avg-val dashed' },
    ]);
  }
  populateViolatedIndexes(data) {
    const violatedIndexes = {
      rule1: [],
      rule6: [],
      rule7: [],
    };
    data.forEach((element, i) => {
      if (element.ruleViolation7) {
        violatedIndexes.rule7.push(i);
      }
      if (element.ruleViolation6) {
        violatedIndexes.rule6.push(i);
      }
      if (element.ruleViolation1) {
        violatedIndexes.rule1.push(i);
      }
    });

    return violatedIndexes;
  }
}
